import { Formik } from "formik";
import React, { useState } from "react";
import Input from "./Pages/Payment/Input";
import { PromotionCodeSheme } from "../validations/PromotionCodeSheme";
import { Dialog } from "@headlessui/react";
import { toast } from "react-toastify";
import { CheckPromotioncode } from "./api";
import { useTranslation } from "../context/TranslationContext";

const PromotionCodeModal = ({ isOpen, setIsOpen, CalculateFunc }) => {
  const { promotionCode, apply } = useTranslation();
  const HandleSubmit = (values, actions) => {
    CheckPromotioncode(values)
      .then((e) => {
        if (e.data.error) {
          toast.error(e.data.error);
          localStorage.removeItem("PromotionCode");
          CalculateFunc();
        } else {
          if (e.data.code) {
            localStorage.setItem("PromotionCode", e.data.code.code);
            CalculateFunc();
            setIsOpen(false);
          }
        }
      })
      .finally(() => {
        actions.setSubmitting(false);
      });
  };
  return (
    <Dialog
      open={isOpen}
      onClose={() => setIsOpen(false)}
      className="relative z-[999]"
    >
      <div className="fixed inset-0 bg-black/30" aria-hidden="true" />
      <div className="fixed inset-0 flex w-screen items-center justify-center p-4">
        <Dialog.Panel className="w-full max-w-md rounded bg-white p-5">
          <Formik
            initialValues={{
              PromotionCode: "",
            }}
            validationSchema={PromotionCodeSheme}
            onSubmit={HandleSubmit}
          >
            {(props) => (
              <form
                className="flex flex-wrap w-full"
                onSubmit={props.handleSubmit}
              >
                <div className="relative z-0 w-full group p-1 mt-4">
                  <Input
                    name="PromotionCode"
                    placeholder=" "
                    label={promotionCode}
                  />
                </div>
                <button
                  type="submit"
                  disabled={
                    props.isSubmitting || !props.isValid || !props.dirty
                  }
                  className="mt-4 text-white mx-auto px-4 py-3 duration-200 bg-[#00BBC0] hover:bg-[#00bac0bb] focus:ring-4 focus:outline-none focus:ring-blue-300  font-medium rounded-lg text-sm  text-center disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {apply}
                </button>
              </form>
            )}
          </Formik>
        </Dialog.Panel>
      </div>
    </Dialog>
  );
};

export default PromotionCodeModal;
